import { parrotApi } from '@libs/openapi';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useAddress } from './use-address';

export const useVaultPoint = () => {
  const address = useAddress();
  const [point, setPoint] = useState<OpenapiClientParrotVault.GetVaultInvitePointsResponse>();

  const getVaultPoint = async () => {
    if (!address) {
      setPoint(undefined);
      return;
    }
    const result = await parrotApi.get('/vault/invite/points', {
      query: {
        owner: address,
      },
    });
    setPoint(result);
  };

  useEffect(() => {
    getVaultPoint();
  }, [address]);

  return {
    point,
  };
};
